import Image from 'next/image';

import { images } from '~/landing/assets';

export const LogoGermen = () => {
  return (
    <div className="flex items-center gap-2">
      <Image
        alt="Germen logo icon"
        height={24}
        src={images.germen['logo-icon']}
        width={24}
      />
      <Image
        alt="Germen logo text"
        height={24}
        src={images.germen['logo-text']}
        width={130}
      />
    </div>
  );
};
